/* Cartes produit clone exact référence :
   - Ajoute classe .product-card--title-overlay
   - Crée .product-card__title-overlay > .product-card__name > .team + .subtitle
   - Texte affiché tel que saisi dans l'admin (sigles PSG, FC, LDC conservés)
*/
(function () {
  'use strict';
  /* log retiré (prod) */

  function process(card) {
    try {
      if (!card || card.dataset.imTitleOverlay === '1') return;

      // Cible le wrapper image (DIV, pas le <a>)
      var imgWr =
        card.querySelector('.product-card__image-wr') ||
        card.querySelector('.product-card__image-wrapper') ||
        card.querySelector('.image-content__image-wrapper');

      if (!imgWr) {
        console.warn('[IM title-overlay] no image wrapper', card);
        return;
      }

      // Récupère le name natif (dans .product-card__info)
      var name = card.querySelector('.product-card__info .product-card__name') ||
                 card.querySelector('.product-card__name');
      if (!name) return;

      var fullText = (name.textContent || '').trim();
      var href = name.getAttribute('href') || '';
      if (!href) {
        var anchor = card.querySelector('a[href*="/products/"]');
        if (anchor) href = anchor.getAttribute('href');
      }

      // Split sur le 1er vrai séparateur : tiret entouré d'espace(s) ou tiret long –/—.
      // Un trait d'union collé (Saint-Germain, Pays-Bas, Saint-Étienne) n'est plus un séparateur.
      var m = fullText.match(/^(.+?)(?:\s+[-–—:]\s+|\s*[–—]\s*|\s+-|-\s+)(.+)$/);
      var team = m ? m[1].trim() : fullText;
      var subtitle = m ? m[2].trim() : '';

      // Casse d'origine conservée (PSG, FC, LDC, OGC…) : plus de passage en minuscules

      // Crée le wrapper overlay
      var overlay = document.createElement('div');
      overlay.className = 'product-card__title-overlay';

      var link = document.createElement('a');
      link.className = 'product-card__name d-block';
      link.setAttribute('href', href || '#');
      link.setAttribute('title', fullText);

      var teamSpan = document.createElement('span');
      teamSpan.className = 'product-card__team';
      teamSpan.textContent = team;
      link.appendChild(teamSpan);

      if (subtitle) {
        var subSpan = document.createElement('span');
        subSpan.className = 'product-card__subtitle';
        subSpan.textContent = subtitle;
        link.appendChild(subSpan);
      }

      overlay.appendChild(link);
      imgWr.appendChild(overlay);

      // Ajoute la classe d'activation
      card.classList.add('product-card--title-overlay');

      card.dataset.imTitleOverlay = '1';
    } catch (e) {
      console.error('[IM title-overlay] error:', e, card);
    }
  }

  function processAll() {
    var cards = document.querySelectorAll('.product-card');
    /* log retiré (prod) */
    cards.forEach(process);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }

  setTimeout(processAll, 800);
  setTimeout(processAll, 2000);

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('.product-card')) process(n);
          if (n.querySelectorAll) n.querySelectorAll('.product-card').forEach(process);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
